import styled from 'styled-components';
import { heading1 } from '../DesignSystem/Typography';

export const Container = styled.div`
  background: var(--black-200);
  flex: 1;
  overflow-x: hidden;

  > div {
    padding-right: var(--space-300);
    padding-left: var(--space-300);
  }

  .containerBody {
    padding-top: var(--space-300);
  }

  &.fixedHeader {
    padding-top: calc(69px);

    .header {
      position: fixed;
      z-index: 100;
      top: var(--site-top-padding);
      right: 0;
      width: calc(100% - var(--sidebar-width));
      padding: 0 var(--space-300);
      background: var(--black-200);
    }

    .containerBody {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &.fullHeight .body {
    padding-bottom: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-top: 14px;
  padding-bottom: 18px;

  min-height: 69px;

  border-bottom: 1px var(--border-color-default) solid;

  gap: 12px;

  &.fixed {
    position: fixed;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const Title = styled.div`
  ${heading1};
  color: var(--text-standard-primary);
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Body = styled.div`
  container-type: inline-size;
  container-name: pageBody;
  display: flex;
  flex-direction: column;
  gap: var(--space-250);
  padding-bottom: var(--site-bottom-padding);
`;
